import { render, staticRenderFns } from "./AppShortcut.vue?vue&type=template&id=82192e88&scoped=true"
import script from "./AppShortcut.vue?vue&type=script&lang=js"
export * from "./AppShortcut.vue?vue&type=script&lang=js"
import style0 from "./AppShortcut.vue?vue&type=style&index=0&id=82192e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82192e88",
  null
  
)

export default component.exports